import { IUserProfileData } from '../../createAndEdit/types';
import { formatRecipientLabel } from '../../utils';

interface IDetailInfoBarProps {
  userProfile?: IUserProfileData;
  origin?: string;
  originUserName?: string;
  recipient?: string;
}

const DetailInfoBar = (props: IDetailInfoBarProps) => {
  const org = props.userProfile?.account || 'Concessionária';
  const senderName = props.originUserName;
  const originLabel = props.origin ? formatRecipientLabel(props.origin) : '';
  const recipientLabel = props.recipient ? formatRecipientLabel(props.recipient) : '';

  return (
    <div className="px-6 mb-4">
      <div className="flex flex-col items-start gap-3 text-size-14">
        <span className="text-gray-600">Enviado por</span>
        <div className="flex flex-row items-center gap-3 text-size-14">          
          {originLabel && (
            <>
              <span className="font-bold">{senderName ?? 'Não identificado'} ({originLabel})</span>
            </>
          )}
          {originLabel && recipientLabel && (
            <>
              <span className="text-gray-400 text-size-16">→</span>
            </>
          )}
          {recipientLabel && (
            <>
              <span className="font-bold">{recipientLabel}</span>
            </>
          )}
        </div>
      </div>
      <div className="border-b border-gray-200 mt-3" />
    </div>
  );
};

export default DetailInfoBar;
